{
  "recordingDashboard": {
    "title": "Cockpit d'enregistrement",
    "subtitle": "Suivez la progression d'enregistrement de tous les processus et résolvez les attributions ouvertes.",
    "progress": {
      "title": "Progression d'enregistrement ({{count}} processus)",
      "completed": "Terminé",
      "inRecording": "En enregistrement",
      "recordingComplete": "Enregistré",
      "notStarted": "Non commencé",
      "pendingAssignment": "En attente"
    },
    "tabs": {
      "notStarted": "Non commencé",
      "inRecording": "En enregistrement",
      "completed": "Terminé"
    },
    "notStarted": {
      "startRecording": "Démarrer l'enregistrement",
      "overdue": "En retard",
      "noProcesses": "Tous les processus ont été démarrés."
    },
    "inRecording": {
      "reassign": "Réattribuer",
      "noProcesses": "Aucun processus n'est en cours d'enregistrement.",
      "pendingStep": "Attribution en attente",
      "openStep": "Étape ouverte"
    },
    "completed": {
      "noProcesses": "Aucun processus terminé pour le moment."
    },
    "surveys": {
      "pending": "En attente",
      "completed": "Terminé",
      "dismissed": "N'effectue pas l'étape"
    },
    "actions": {
      "openProcess": "Ouvrir le processus",
      "toggleDetails": "Afficher/masquer les détails"
    },
    "columns": {
      "process": "Processus",
      "owner": "Responsable",
      "status": "Statut",
      "statusRecording": "Statut d'enregistrement",
      "step": "Étape",
      "actions": "Actions",
      "unassigned": "Non assigné",
      "dueDate": "Date d'échéance",
      "type": "Type",
      "assignee": "Responsable"
    },
    "subTable": {
      "step": "Étape",
      "survey": "Enquête",
      "hideCompleted": "Masquer les terminés",
      "assignment": "Attribution",
      "cannotNudgeNonPerson": "Vous ne pouvez relancer que des personnes."
    },
    "status": {
      "openAssignments_one": "{{count}} attribution en attente",
      "openAssignments_other": "{{count}} attributions en attente",
      "inRecordingSteps": "{{count}} étapes en enregistrement",
      "pendingSurveys": "{{count}} enquêtes en attente",
      "overdue": "{{count}} en retard",
      "stepsComplete": "{{completed}}/{{total}} étapes enregistrées",
      "stepsTooltip": "Étapes enregistrées / total des étapes connues"
    },
    "nudge": {
      "title": "Envoyer un rappel",
      "description": "Envoyer un rappel à {{name}} concernant sa tâche d'enregistrement pour {{process}}.",
      "messagePlaceholder": "Ajouter un message personnel...",
      "send": "Envoyer le rappel",
      "success": "Rappel envoyé avec succès."
    }
  }
}
